import { render } from "./InstanceTab.vue?vue&type=template&id=fb0b76f8&scoped=true"
import script from "./InstanceTab.vue?vue&type=script&lang=js"
export * from "./InstanceTab.vue?vue&type=script&lang=js"

import "./InstanceTab.vue?vue&type=style&index=0&id=fb0b76f8&lang=scss&scoped=true"
import "./InstanceTab.vue?vue&type=style&index=1&id=fb0b76f8&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0b76f8"]])

export default __exports__